import { normalizeLocale } from 'src/i18n/config'

const pluralRules = new Map()

const getPluralRules = (locale) => {
  const key = normalizeLocale(locale) || 'pl'

  if (!pluralRules.has(key)) {
    try {
      pluralRules.set(key, new Intl.PluralRules(key))
    } catch {
      pluralRules.set(key, new Intl.PluralRules('pl'))
    }
  }

  return pluralRules.get(key)
}

const CATEGORY_SUFFIXES = {
  zero: '_ZERO',
  one: '_ONE',
  two: '_TWO',
  few: '_FEW',
  many: '_MANY',
  other: '_OTHER',
}

/**
 * Kategoria liczby mnogiej dla danego języka: polski ma trzy (1 wynik / 2–4 wyniki / 5+ wyników,
 * z wyjątkami 12–14), angielski dwie. `Intl.PluralRules` wybiera właściwą sam.
 */
export const getPluralCategory = (count, locale) => getPluralRules(locale).select(Number(count) || 0)

/**
 * Zwraca tłumaczenie w formie pasującej do liczby. Szuka klucza `BASE_ONE` / `_FEW` / `_MANY` …,
 * a gdy wariantu brakuje w bazie, schodzi do `_OTHER` i na końcu do samego `BASE`.
 * `translateEntry` zwraca kod klucza, jeśli go nie zna — po tym poznajemy brak wariantu.
 */
export const translatePlural = (translateEntry, baseKey, count, locale) => {
  const category = getPluralCategory(count, locale)
  const candidates = [CATEGORY_SUFFIXES[category], '_OTHER', '_MANY', '']

  for (const suffix of candidates) {
    if (suffix === undefined) continue

    const key = `${baseKey}${suffix}`
    const translation = translateEntry(key)

    if (translation && translation !== key) return translation
  }

  return ''
}

/**
 * „Znaleziono: 4 wyniki" — z poprawną odmianą rzeczownika.
 */
export const formatResultsFound = (count, locale, translateEntry) => {
  const total = Number(count) || 0
  const prefix = translateEntry('T_RESULTS_FOUND_PREFIX')
  const noun = translatePlural(translateEntry, 'T_RESULTS_FOUND', total, locale)

  return `${prefix}: ${total} ${noun}`.trim()
}
